// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"CookiesView_Wrapper__2BPIJ","Image":"CookiesView_Image__1YIeL","Text":"CookiesView_Text__1bn0U"};